import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: () => import("@/views/Login/index.vue")
  },
  {
    path: '/SearchEngine',
    name: 'SearchEngine',
    component: () => import("@/views/Search/HomePage.vue")
  },
  {
    path: '/IntelligenceField',
    name: 'IntelligenceField',
    component: () => import("@/views/IntelligenceField")
  },
  {
    path: '/News',
    name: 'News',
    component: () => import("@/views/News/index.vue")
  },
  {
    path: '/GlobalSituation',
    name: 'GlobalSituation',
    component: () => import("@/views/GlobalSituation/index.vue"),
  },
  {
    path: '/DomesticSituation',
    name: 'DomesticSituation',
    component: () => import("@/views/DomesticSituation/index.vue"),
  },
  {
    path: '/InformationContrast',
    name: 'InformationContrast',
    component: () => import("@/views/InformationContrast")
  },
  {
    path: '/DomainHotWords',
    name: 'DomainHotWords',
    component: () => import("@/views/DomainHotWords")
  },
  {
    path: '/Newpage',
    name: 'Newpage',
    component: () => import("@/views/Newpage/index.vue")
  },
  {
    path: '/KnowledgeGraph',
    name: 'KnowledgeGraph',
    component: () => import("@/views/KnowledgeGraph/index.vue")
  },
  {
    path: '/networkManagement',
    name: 'networkManagement',
    component: () => import("@/views/NetworkManagement/networkManagement.vue")
  },
  {
    path: '/KnowledgeExtraction',
    name: 'KnowledgeExtraction',
    component: () => import("@/views/KnowledgeExtraction/index.vue")
  },
  {
    path: '/Meet20',
    name: 'Meet20',
    component: () => import("@/views/Meet20/index.vue")
  },
]

//去除重复跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
